import React from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram, FaFacebookF, FaWhatsapp } from 'react-icons/fa';
import logo from '../../image/logo.webp';

const ThankYou = () => {
  return (
    <div style={{ backgroundColor: '#0B4F55', minHeight: '100vh', padding: '60px 20px', display: 'flex', flexDirection: 'column', alignItems: 'center', fontFamily: '"Inter", "Segoe UI", sans-serif' }}>
      
      {/* Logo */}
      <div className="mb-5" style={{ animation: 'fadeInDown 0.8s ease-out' }}>
        <Link to="/">
          <div style={{ backgroundColor: 'white', padding: '15px 25px', borderRadius: '15px', boxShadow: '0 10px 25px rgba(0,0,0,0.2)', display: 'inline-block', transition: 'transform 0.3s ease' }} 
               onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
               onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}>
            <img src={logo} alt="Chemo Biologicals" style={{ height: '50px' }} />
          </div>
        </Link>
      </div>

      {/* Main Thank You Box */}
      <div style={{ backgroundColor: 'white', width: '100%', maxWidth: '800px', padding: '50px 30px', textAlign: 'center', marginBottom: '30px', borderRadius: '20px', boxShadow: '0 15px 35px rgba(0,0,0,0.2)', animation: 'fadeInUp 0.8s ease-out' }}>
        <h1 style={{ fontWeight: '800', color: '#0B4F55', marginBottom: '20px', fontSize: '2.5rem' }}>Thank You!</h1>
        <hr style={{ borderTop: '2px solid #e0e0e0', margin: '25px auto', width: '80%' }} />
        <p style={{ fontSize: '1.1rem', color: '#555', marginBottom: '30px', lineHeight: '1.6', fontWeight: '500' }}>
          Thanks, we've received your submission and will be in touch soon.<br/> Your interest means a lot to us. Stay tuned!
        </p>
        <p style={{ fontSize: '1.1rem', color: '#333', marginBottom: '0', fontWeight: 'bold' }}>
          Best Regards,<br />
          <span style={{ color: '#0B4F55' }}>Chemo Biological</span>
        </p>
      </div>

      {/* Two Columns for Social & Website */}
      <div style={{ width: '100%', maxWidth: '800px', display: 'flex', gap: '30px', flexWrap: 'wrap', animation: 'fadeInUp 1s ease-out' }}>
        
        {/* Like & Share */}
        <div style={{ flex: '1 1 calc(50% - 15px)', backgroundColor: 'white', padding: '40px 30px', textAlign: 'center', borderRadius: '20px', boxShadow: '0 10px 30px rgba(0,0,0,0.15)' }}>
          <h4 style={{ fontWeight: '700', color: '#333', marginBottom: '25px', fontSize: '1.3rem' }}>Like & Share</h4>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
            <a href="https://www.instagram.com/chemobiological?igsh=NjZ5Y242dGcyazg5" target="_blank" rel="noreferrer" 
               style={{ backgroundColor: '#0B4F55', color: 'white', width: '50px', height: '50px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', textDecoration: 'none', transition: 'all 0.3s ease', boxShadow: '0 5px 15px rgba(11, 79, 85, 0.4)' }}
               onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#E1306C'; e.currentTarget.style.transform = 'translateY(-3px)'; }}
               onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#0B4F55'; e.currentTarget.style.transform = 'translateY(0)'; }}>
              <FaInstagram size={24} />
            </a>
            <a href="https://www.facebook.com/people/ChemoBiological/61569662266911/?rdid=ZpmlRrEZWnwRxlv4&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1DTCqNyQ7g%2F" target="_blank" rel="noreferrer" 
               style={{ backgroundColor: '#0B4F55', color: 'white', width: '50px', height: '50px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', textDecoration: 'none', transition: 'all 0.3s ease', boxShadow: '0 5px 15px rgba(11, 79, 85, 0.4)' }}
               onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#1877F2'; e.currentTarget.style.transform = 'translateY(-3px)'; }}
               onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#0B4F55'; e.currentTarget.style.transform = 'translateY(0)'; }}>
              <FaFacebookF size={24} />
            </a>
            <a href="https://wa.me/917827552889" target="_blank" rel="noreferrer" 
               style={{ backgroundColor: '#0B4F55', color: 'white', width: '50px', height: '50px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', textDecoration: 'none', transition: 'all 0.3s ease', boxShadow: '0 5px 15px rgba(11, 79, 85, 0.4)' }}
               onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#25D366'; e.currentTarget.style.transform = 'translateY(-3px)'; }}
               onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#0B4F55'; e.currentTarget.style.transform = 'translateY(0)'; }}>
              <FaWhatsapp size={24} />
            </a>
          </div>
        </div>

        {/* Visit Our Website */}
        <div style={{ flex: '1 1 calc(50% - 15px)', backgroundColor: 'white', padding: '40px 30px', textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', borderRadius: '20px', boxShadow: '0 10px 30px rgba(0,0,0,0.15)' }}>
          <h4 style={{ fontWeight: '700', color: '#333', marginBottom: '20px', fontSize: '1.3rem' }}>Explore More</h4>
          <a href="https://chemobiologicals.com/" style={{ backgroundColor: '#0B4F55', color: 'white', padding: '12px 30px', borderRadius: '30px', textDecoration: 'none', fontWeight: 'bold', fontSize: '1rem', transition: 'all 0.3s ease', boxShadow: '0 5px 15px rgba(11, 79, 85, 0.4)' }}
             onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#083B40'; e.currentTarget.style.transform = 'scale(1.05)'; }}
             onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#0B4F55'; e.currentTarget.style.transform = 'scale(1)'; }}>
            Visit Our Website
          </a>
        </div>

      </div>

      <style>
        {`
          @keyframes fadeInUp {
            from { opacity: 0; transform: translateY(30px); }
            to { opacity: 1; transform: translateY(0); }
          }
          @keyframes fadeInDown {
            from { opacity: 0; transform: translateY(-30px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>
    </div>
  );
};

export default ThankYou;
